// Product Page Interactions
(function() {
  // Image gallery functionality
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  const mainImage = document.querySelector('.product-main-image__img');
  
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      // Remove active class from all thumbnails
      thumbnails.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked thumbnail
      thumbnail.classList.add('active');
      
      // Update main image
      if (mainImage) {
        const newImageUrl = thumbnail.dataset.imageUrl;
        const newImageAlt = thumbnail.dataset.imageAlt;
        
        mainImage.src = newImageUrl;
        mainImage.alt = newImageAlt;
      }
    });
  });

  // Quantity selector functionality
  const quantityInput = document.getElementById('product-quantity');
  const minusBtn = document.querySelector('.quantity-btn--minus');
  const plusBtn = document.querySelector('.quantity-btn--plus');
  
  if (quantityInput && minusBtn && plusBtn) {
    const updateQuantity = (change) => {
      const currentValue = parseInt(quantityInput.value) || 1;
      const newValue = Math.max(1, currentValue + change);
      quantityInput.value = newValue;
      
      // Update button states
      minusBtn.disabled = newValue <= 1;
    };

    minusBtn.addEventListener('click', () => updateQuantity(-1));
    plusBtn.addEventListener('click', () => updateQuantity(1));
    
    // Initialize button state
    updateQuantity(0);
  }

  // Variant selector functionality
  const variantSelect = document.getElementById('product-variant-select');
  const priceElements = {
    regular: document.querySelector('.product-price--regular'),
    compare: document.querySelector('.product-price--compare'),
    sale: document.querySelector('.product-price--sale'),
    save: document.querySelector('.product-price--save')
  };
  const submitButton = document.getElementById('product-form-submit');
  const btnText = submitButton?.querySelector('.btn-text');
  
  if (variantSelect && window.productVariants) {
    variantSelect.addEventListener('change', (e) => {
      const selectedVariantId = e.target.value;
      const selectedVariant = window.productVariants.find(v => v.id == selectedVariantId);
      
      if (selectedVariant) {
        // Update prices
        updatePrices(selectedVariant);
        
        // Update button state
        updateSubmitButton(selectedVariant);
      }
    });
  }

  function updatePrices(variant) {
    const price = variant.price;
    const comparePrice = variant.compare_at_price;
    const isOnSale = comparePrice && comparePrice > price;
    
    if (isOnSale) {
      // Show sale pricing
      if (priceElements.regular) priceElements.regular.style.display = 'none';
      if (priceElements.compare) {
        priceElements.compare.textContent = formatMoney(comparePrice);
        priceElements.compare.style.display = 'inline';
      }
      if (priceElements.sale) {
        priceElements.sale.textContent = formatMoney(price);
        priceElements.sale.style.display = 'inline';
      }
      if (priceElements.save) {
        priceElements.save.textContent = `Save ${formatMoney(comparePrice - price)}`;
        priceElements.save.style.display = 'inline';
      }
    } else {
      // Show regular pricing
      if (priceElements.regular) {
        priceElements.regular.textContent = formatMoney(price);
        priceElements.regular.style.display = 'inline';
      }
      if (priceElements.compare) priceElements.compare.style.display = 'none';
      if (priceElements.sale) priceElements.sale.style.display = 'none';
      if (priceElements.save) priceElements.save.style.display = 'none';
    }
  }

  function updateSubmitButton(variant) {
    if (submitButton && btnText) {
      if (variant.available) {
        submitButton.disabled = false;
        btnText.textContent = 'Add to Cart';
      } else {
        submitButton.disabled = true;
        btnText.textContent = 'Sold Out';
      }
    }
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }

  // Smooth scroll animations for product page elements
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  // Observe product elements for animation
  const animateElements = document.querySelectorAll('.product-header, .product-description, .product-form-wrapper, .product-features');
  animateElements.forEach((el) => {
    el.classList.add('animate-on-scroll', 'fade-up');
    observer.observe(el);
  });
})();
